const config = require("../config")

module.exports = {
    //病虫害列表查询
    abnormalPlan: {
        url: config.base_new_url + "pest_abnormal_plan",
        type: "get",
    },
    //生长异常列表查询
    growthAnomalyInfo: {
        url: config.base_new_url + "get_growth_anomaly_info",
        type: "get",
    },
    //获取分区记录图片
    farmImages: {
        url: config.base_new_url + "farm_images",
        type: "get",
    },
    //互动问题记录
    writeFarmRecord: {
        url: config.base_new_url + "write_farm_record",
        type: "post",
    },
    //识别病虫害
    batchPestIdentify: {
        url: config.base_new_url + "batch_pest_identify",
        type: "post",
    },
    //分区格网生成
    generateGrid: {
        url: config.base_new_url + "generate_terrain_grids",
        type: "get",
    },
    //获取遥感时序数
    getZoneRsSeries: {
        url: config.base_new_url + "get_zone_rs_series",
        type: "get",
    },
}